import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const smValue = EnvVarsService.getVar('VITE_SM_VALUE', true);

// Width
const maxFullWidth = 1780;
const maxFixedWidth = 1460;

// Media queries
const mobile = 375;
const tablet = 768;
const desktopXs = 900;
const desktopSm = 1024;
const laptop = smValue ?? 1280;
const desktopLg = 1460;
const desktopMl = 1680;
const desktopXl = 1920;

const size = {
	maxFullWidth,
	maxFixedWidth,
	mobile,
	tablet,
	desktopXs,
	desktopSm,
	laptop,
	desktopLg,
	desktopMl,
	desktopXl,
};

export default size;
